import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-home-featured-services',
  templateUrl: './home-featured-services.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./home-featured-services.component.scss']
})
export class HomeFeaturedServicesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
